import { sendAjax } from "../utils/sendAjax"

const successHtml = "<h2>Заявка отправлена</h2>"

export const appointmentFormRules = {
    submitHandler: function (form, event) {
        event.preventDefault();

        const obForm = new FormData(form);
        const errorContainer = $(form).find(".errors"); // Контейнер для ошибок

        sendAjax("/local/ajax/ajaxFormHandler.php", obForm, function (data) {
            if (data.success) {
                $(form).replaceWith(successHtml);
                $(form).find(".g-recaptcha").hide();
            } else {
                let errorText
                console.error(data.errors)
                if (Array.isArray(data.errors)) {
                    errorText = Object.values(data.errors).join(", ")
                } else {
                    errorText = data.errors
                }
                grecaptcha.reset();
                errorContainer.text(errorText);
            }
        });
    },
    rules: {
        form_text_2: {
            required: true,
        },
        form_text_3: {
            required: true,
            minlength: 2,
        },
        form_text_4: {
            required: true,
            minlength: 2,
        },
        form_text_5: {
            required: true,
            minlength: 2,
        },
        form_text_6: {
            required: true,
            minlength: 5,
        },
        form_date_7: {
            required: true,
            date: true,
        },
    },
    messages: {
        form_text_2: "Пожалуйста, выберите салон.",
        form_text_3: "Имя обязательно для заполнения.",
        form_text_4: "Фамилия обязательна для заполнения.",
        form_text_5: "Отчество обязательно для заполнения.",
        form_text_6: "Введите корректный номер телефона.",
        form_date_7: "Укажите желаемую дату.",
    },
    errorPlacement: function (error, element) {
        if (element.attr("type") == "radio") {
            error.insertBefore(element.parent());
        } else {
            error.insertAfter(element);
        }
        return true;
    },
    focusInvalid: true
};
export const callFormRules = {
    submitHandler: function (form, event) {
        event.preventDefault();

        const obForm = new FormData(form);
        const errorContainer = $(form).find(".errors");

        sendAjax("/local/ajax/ajaxFormHandler.php", obForm, function (data) {
            if (data.success) {
                $(form).replaceWith(successHtml);
                $(form).find(".g-recaptcha").hide();
            } else {
                let errorText
                console.error(data.errors)
                if (Array.isArray(data.errors)) {
                    errorText = Object.values(data.errors).join(", ")
                } else {
                    errorText = data.errors
                }
                grecaptcha.reset();
                errorContainer.text(errorText);
            }
        });
    },
    rules: {
        form_email_8: {
            required: true,
            email: true,
        },
        form_text_9: {
            required: true,
            minlength: 5,
        },
    },
    messages: {
        form_email_8: "Почта обязательна для заполнения.",
        form_text_9: "Введите корректный номер телефона.",
    },
    errorPlacement: function (error, element) {
        if (element.attr("type") == "radio") {
            error.insertBefore(element.parent());
        } else {
            error.insertAfter(element);
        }
        return true;
    },
    focusInvalid: true
};
